module.exports = __webpack_public_path__ + "static/media/ic-view-list-disabled.4e518e00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-view-list-disabled.svg
// module id = 1368
// module chunks = 0